<template>
  <v-card tile flat>
    <ProductPreview :key="gift.id" :id="gift.product_id" :name="gift.product.name" :image="gift.product.image" :points="gift.product.points" />
    <div class="d-flex">
      <CancelPointRedemptionRequestModal v-if="isKid && gift.open" :itemId="gift.id" />
      <VerifyPointRedemptionRequestModal v-if="isParent && gift.open" :itemId="gift.id" :childId="gift.user_id" class="ma-2 ml-0" />
      <RejectPointRedemptionRequestModal v-if="isParent && gift.open" :itemId="gift.id" :childId="gift.user_id" class="ma-2 ml-0" />
      <div v-if="isKid && !gift.open && gift.approved" class="ma-2 text-capitalize accent--text body-heading-medium">Verified</div>
    </div>
  </v-card>
</template>

<script>
  import ProductPreview from "@/components/Products/Preview";
  import CancelPointRedemptionRequestModal from "./CancelPointRedemptionRequestModal";
  import VerifyPointRedemptionRequestModal from "./VerifyPointRedemptionRequestModal";
  import RejectPointRedemptionRequestModal from "./RejectPointRedemptionRequestModal";

  export default {
    name: "KidPurchasedGiftListItem",

    props: {
      gift: {
        type: Object,
        required: true,
      },
    },

    components: { ProductPreview, CancelPointRedemptionRequestModal, VerifyPointRedemptionRequestModal, RejectPointRedemptionRequestModal },

    computed: {
      user() {
        return this.$store.getters.userInfo;
      },
      isParent() {
        return this.$store.getters.userInfo.role === "parent";
      },
      isKid() {
        return this.$store.getters.userInfo.role === "child";
      },
    },
  };
</script>



// WEBPACK FOOTER //
// src/components/Kids/PurchasedGift/KidPurchasedGiftListItem.vue